import React from "react";
import SuperProductForm from "./SuperProductForm";

const SuperAddProduct = (props) => (
  <SuperProductForm shopId={props.id} shopName={props.shopName} subMenuId={props.subMenuId} />
);

export default SuperAddProduct;
